import { Link, type LinkProps } from '@tanstack/react-router';
import type { FC, ReactNode } from 'react';
import type { TextPropsWithLink } from '../helpers/types';

/**
 * TanStack Router Link コンポーネント
 */
export const RouterLink: FC<{
  props: TextPropsWithLink;
  className: string;
  onClick?: () => void;
  children: ReactNode;
}> = ({ props, className, onClick, children }) => {
  const routerLinkProps: {
    to: NonNullable<LinkProps['to']>;
    search?: NonNullable<LinkProps['search']>;
    params?: NonNullable<LinkProps['params']>;
    hash?: NonNullable<LinkProps['hash']>;
  } = { to: props.to };

  if (props.search !== undefined) {
    routerLinkProps.search = props.search;
  }
  if (props.params !== undefined) {
    routerLinkProps.params = props.params;
  }
  if (props.hash !== undefined) {
    routerLinkProps.hash = props.hash;
  }

  return (
    <Link {...routerLinkProps} className={className} onClick={onClick}>
      {children}
    </Link>
  );
};
